export const translationStatistics_en_part5 = {
  // Additional error and UI messages
  authTokenNotFound: "Authentication token not found.",
  errorFetchingUsers: "Error fetching users",
  errorFetchingUserIndexes: "Error fetching user's knowledge base indexes",
  noTextContentFound: "No text content found in PDF",
  errorExtractingPdfText: "Error extracting text from PDF. Please try again.",
  selectAccessibleUser: "Select Accessible User",
  selectAccessibleUserPlaceholder: "Select accessible user",
  selectUser: "Select User",
  selectUserToManage: "Select User to Manage",
  selectUserToManagePlaceholder: "Select user to manage",
  noMatchingResults: "No matching results found",
  noDataFoundForUser: "No data found for {username}",
  noDataFound: "No data found",
  // Text chunking translations
  // Text chunking translations
  textChunkingWarningTitle: "Text requires chunking",
  textChunkingWarningMessage:
    "Your text is {chars} characters long and exceeds the 25,000 character limit. You have two options:",
  textChunkingAutoOption: "Automatic chunking",
  textChunkingAutoDescription:
    "The system will automatically split your text into {chunks} meaningful chunks with 10% overlap.",
  textChunkingManualOption: "Manual split",
  textChunkingManualDescription: "Go back and split the text into smaller sections yourself.",
  textChunkingProceed: "Chunk automatically",
  textChunkingGoBack: "Go back",
  textChunkingInProgress: "Chunking text...",
  textChunkUploadNote: "Each chunk will be uploaded as a separate, searchable entry",
  // Folder management translations
  // Folder management translations
  createFolder: "Create Folder",
  createNewFolder: "Create New Folder",
  folderName: "Folder Name",
  enterFolderName: "Enter folder name",
  parentFolder: "Parent Folder",
  selectParentFolder: "Select parent folder",
  rootNoFolder: "Root (No Folder)",
  uploadToFolder: "Upload to Folder",
  selectFolder: "Select folder",
  folderNameRequired: "Folder name is required",
  folderCreatedSuccessfully: "Folder created successfully",
  errorCreatingFolder: "Error creating folder",
  creatingFolder: "Creating...",
  uploadToThisFolder: "Upload to this folder",
  entryMovedToFolder: "Entry moved to folder",
  entryMovedToRoot: "Entry moved to root",
  errorMovingEntryToFolder: "Failed to move entry to folder",
  dragToMove: "Drag to move",
  noIndexesAvailable: "No knowledge bases available",
  numberOfChunks: "Number of chunks",
  renameFolder: "Rename Folder",
  renameFolderButton: "Rename",
  renamingFolder: "Renaming...",
  folderRenamedSuccessfully: "Folder renamed successfully",
  errorRenamingFolder: "Failed to rename folder",
  changesSavedSuccessfully: "Changes saved successfully",
};
